<template>
  <!-- Card lado direito -->
  <div class="col py-3 d-none d-md-flex">
    <section>
      <div class="card mb-3">
        <div class="card-header card-chart-medium">
          <span v-text="$ml.get('summaryCard')">Resumo dos relatórios</span>
        </div>
        <div
          class="card-body card-chart-body pb-0 pt-1 d-flex flex-column justify-content-left"
        >
          <div class="row">
            <div class="col-12 border-r-d mt-2 mb-2">
              <span class="pb-1" v-text="$ml.get('dashReportResolv')"
                >Relatórios aprovados</span
              >
              <h6>{{ approved_reports ?? 0 }}</h6>
            </div>
            <div class="col-12 pl-3 mt-2 mb-2">
              <span class="pb-1" v-text="$ml.get('scope')">Escopo</span>
              <h6>{{ amount_of_scopes }}</h6>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  name: "CardResumeProgram",
  props: ["approved_reports", "amount_of_scopes"],
};
</script>
